let BASE_URL = "";

if (process.env.NODE_ENV === "development") {
  BASE_URL = "http://localhost:3000";
} else if (process.env.NODE_ENV === "production") {
  BASE_URL = "https://app.relinqsales.com.br";
}

BASE_URL += "/api";

const LOGIN = {
  POST_LOGIN: BASE_URL + "/acessar",
  POST_LOGIN_ADMIN: BASE_URL + "/acessar-admin",
};

const PASSWORD_RECOVERY = {
  FORGOT: "/forgot-password",
  RESET: "/reset-password",
};

const LOAN = {
  GET_LOAN_BY_IDENTIFIER: "/form",
  PUBLIC_FORM: (slug) => `/form/${slug}`,
  GET_DOCUMENT_TYPES: "/document-types",
  GET_SEGMENTS: "/segments",
  UPLOAD_PARTIAL_FORM: "/form/upload-partial",
  UPLOAD_LOAN_DOCUMENT: "/form/upload-document",
  GET_ALL: "/loans",
  INVALIDATE_DOCUMENT: "/document/invalidate",
  GET_DASHBOARD_DATA: "/dashboard/data",
  GET_DASHBOARD_DAILY_DATA: "/dashboard/daily",
  CREATE_NEW: "/simulation-admin",
  PREPARE_SIGN: "/prepare-sign",
};

const API = {
  GET_TOKEN: "/get-api-rest-token",
};

const BLACKLIST = {
  GET_ALL: "/blacklists",
  GET: "/blacklist",
  SEARCH: "/blacklist/search",
};

const CATEGORIES = {
  GET_ALL: "/categories",
  CREATE: "/categories",
  UPDATE: (id) => `/categories/${id}`,
  DELETE: (id) => `/categories/${id}`,
};

const COMPANY = {
  GET_PERMISSION_QUERIES: "/company/permission/queries",
  GET_DOCS: "/company/docs",
  GET_EXTERNAL_INFO: "/company/external-info",
};

const USERS = {
  GET_USERS: "/users",
  GET_USER: "/user",
  GET_USER_CURRENT: "/user-current",
  GET_USER_QUERY_PERMISSIONS: "/user-query/permission",
  GET_USER_BY_EMAIL: "/user/email",
};

const ADMIN = {
  GET_CUSTOMERS: "/admin/customers",
  GET_REPRESENTATIVES: "/admin/representatives",
  GET_COMPANY_QUERIES: "/admin/company/queries",
  GET_QUERIES: "/admin/queries",
  GET_USERS: "/admin/users",
  GET_SYSTEM_USERS: "/admin/system/users",
  GET_FILTER_OPTIONS: "/admin/filters/options",
  GET_DASHBOARD: "/admin/dashboard",
  IMPERSONATE_USER: (id) => `/admin/user/${id}/impersonate`,
  GET_PROVIDERS: "/admin/providers",
  GET_PROVIDERS_ALL: "/admin/providers-all",
  NEW_CUSTOMER: "/customer/new",
  NEW_REPRESENTATIVE: "/admin/representative/new",
  GET_COMPANY_BY_INFO: "/admin/company/info",
  GET_COMPANIES_OVERVIEW: "/admin/companies/overview",
  GET_COMPANY_DETAIL: (id) => `/admin/company/${id}/detail`,
  GET_COMPANY: "/admin/company",
  UPDATE_COMPANY: (id) => `/admin/company/${id}`,
  GET_COMPANY_QUERIES_HISTORY: "/admin/queries/company",
  GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED: "/admin/queries/company/simplified",
  GET_PAYMENTS: "/admin/payments",
  GET_QUERY: "/admin/query",
  GET_TABLE_QUERIES: "/admin/table/queries",
  GET_TABLES: "/admin/tables",
  GET_TABLE: "/admin/table",
  GET_SURVEY_REPORT: "/admin/survey/company",
  GET_CUSTOMIZED_QUERY: "/admin/customized-query",
  GET_HISTORY_INVOICES: "/admin/invoices/history",
  GET_COMPANIES: "/admin/company",
};

const CHARGES = {
  SEND: "/charge/send",
  GET_ALL: "/charges",
  GET: "/charge",
  GET_TYPES: "/charges/types",
};

const DASHBOARD = {
  GET_ALL: `/dashboard`,
  GET_SUMMARY: `/dashboard/summary`,
  GET_PIPELINE: `/dashboard/pipeline`,
  GET_FORECAST: `/dashboard/forecast`,
  GET_VELOCITY: `/dashboard/velocity`,
  GET_SOURCES: `/dashboard/sources`,
  GET_LEADERBOARD: `/dashboard/leaderboard`,
  GET_FOLLOW_UPS: `/dashboard/follow-ups`,
  GET_RISKS: `/dashboard/risks`,
};

const QUERIES = {
  GET_LOCALIZA_CNPJ: "/query/localiza-cnpj",
  GET_LAST_QUERIES: "/query/last",
  GET_LAST_7_DAYS_COUNT_QUERIES: "/query/total/last/7",
  GET_QUERIES_TOTAL: "/query/total",
  GET_QUERIES_LIST: "/queries",
  UPLOAD_PDF: "/query/upload/pdf",
  DOWNLOAD_PDF: "/query/download/pdf",
  GENERATE_PDF: "/generate/pdf",
  GET_DASHBOARD_INFOS: "/query/dashboard",
  GET_DASHBOARD_INFOS_REPRESENTATIVE: "/query/dashboard/representative",
  GET_DASHBOARD_INFOS_POWER_USER: "/query/dashboard/power-user",
  GET_V1_QUERY: "/v1",
  GET_V2_QUERY: "/v2",
  GET_USER_QUERY: "/query/user-query",
};

const QUERIES_VEICULAR = {
  GET_COMPLETA_VEICULAR: "/query/completa-veicular",
  GET_LEILAO_POSITIVO: "/query/leilao-positivo",
  GET_VEICULAR: "/query/veicular",
  GET_PRECIFICADOR: "/query/veicular/precificador",
  GET_BIN_NACIONAL: "/query/veicular/bin-nacional",
};

const INTEGRATIONS = {
  OPEN_CNPJ_COMPANIES: "/integrations/opencnpj/empresas",
  GOOGLE_CALENDAR_URL: "/integrations/google-calendar/url",
  GOOGLE_CALENDAR_TOKEN: "/integrations/google-calendar/token",
  COMPANY_ACCESS_MATRIX: "/integrations/company-access",
  COMPANY_ACCESS_CURRENT: "/integrations/company-access/current",
  COMPANY_ACCESS_SET: "/integrations/company-access",
  LIST_TOKENS: "/integrations/tokens",
  DELETE_TOKEN: (type) => `/integrations/tokens/${type}`,
  GOOGLE_CALENDAR_EVENTS: "/integrations/google-calendar/events",
};

const AUDITS = {
  GET_AUDITS: "/audits",
};

const AVATAR = {
  UPLOAD: "/avatar/upload",
};

const PAYMENTS = {
  CREATE: "/payment/create",
  CREATE_PAYMENT_ADMIN: "/admin/payment/create",
  GET_ALL: "/invoices",
  ADD_CREDIT: "/payment/confirm",
  ADD_CREDIT_MANUALLY: "/payment/manually",
};

const REPORTS = {
  GET_COMPANY_QUERIES_HISTORY: "/report/queries/company",
  GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED: "/report/queries/company/simplified",
};

const SURVEYS = {
  GET_SURVEY: "/survey",
  GET_ALL_SURVEY: "/surveys",
  GET_TAGS: "/survey/tags",
  GET_SURVEY_VEHICLE: "/survey/vehicle",
  GET_SURVEY_CHECKLIST: "/survey/checklist",
  GET_CHECKLIST: "/survey/questions",
  UPLOAD_IMAGE: "/survey/image/upload",
  GET_SURVEY_IMAGES: "/survey/images",
  GET_CONFIG: "/survey/configs",
  FINISH: "/survey/finish",
  GET_REPORT: "/survey/report",
  DELETE_IMAGE_SURVEY: "/survey/image/upload",
};

const CRM = {
  FUNNELS: "/crm/funnels",
  FUNNEL_DETAILS: "/crm/funnel",
  CREATE_FUNNEL: "/crm/funnels",
  UPDATE_FUNNEL: "/crm/funnels", // + /:funnelId
  DELETE_FUNNEL: "/crm/funnels", // + /:funnelId

  CREATE_STAGE: "/crm/stages",
  UPDATE_STAGE: "/crm/stages", // + /:stageId
  DELETE_STAGE: "/crm/stages", // + /:stageId

  FUNNEL_PUBLIC_FORM: (funnelId) => `/crm/funnels/${funnelId}/public-form`,

  // ⭐️ NOVOS ENDPOINTS
  STAGE_REQUIRED_FIELDS: "/crm/stages", // + /:stageId/required-fields
  AUTOMATIONS_LIST: (funnelId) => `/crm/funnels/${funnelId}/automations`,
  AUTOMATIONS_CREATE: (funnelId) => `/crm/funnels/${funnelId}/automations`,
  UPDATE_AUTOMATION: (automationId) => `/crm/automations/${automationId}`,
  DELETE_AUTOMATION: (automationId) => `/crm/automations/${automationId}`,
  AUTOMATIONS_LOGS: (automationId) => `/crm/automations/${automationId}/logs`,

  CREATE_CARD: "/crm/card",
  GET_CARD: "/crm/card",
  UPDATE_CARD: "/crm/card", // + /:cardId
  DELETE_CARD: "/crm/card", // + /:cardId

  ADD_CARD_HISTORY: "/crm/card", // + /:cardId/history
  GET_CARD_HISTORY: "/crm/card", // + /:cardId/history
  CREATE_TASK: "/crm/card", // + /:cardId/tasks
  LIST_TASKS: "/crm/card", // + /:cardId/tasks
  UPDATE_TASK: "/crm/task", // + /:taskId
  COMPLETE_TASK: "/crm/task", // + /:taskId/complete
  CANCEL_TASK: "/crm/task", // + /:taskId/cancel
  DELETE_TASK: "/crm/task", // + /:taskId
  POSTPONE_TASK: "/crm/tasks", // + /:taskId/postpone
  TODAY_TASKS: "/crm/tasks/today",

  TASK_ATTACHMENT_URL: (cardId, taskId, id) =>
    `/cards/${cardId}/tasks/${taskId}/attachments/${id}`,
  TASK_ATTACHMENT_SIGNED_URL: (cardId, taskId, id) =>
    `/cards/${cardId}/tasks/${taskId}/attachments/${id}/url`,

  CARD_ATTACHMENTS: (cardId) => `/crm/card/${cardId}/attachments`,
  CARD_ATTACHMENT_URL: (cardId, id) => `/cards/${cardId}/attachments/${id}`,
  CARD_ATTACHMENT_SIGNED_URL: (cardId, id) =>
    `/cards/${cardId}/attachments/${id}/url`,
  CARD_ATTACHMENT_DELETE: (cardId, id) =>
    `/crm/card/${cardId}/attachments/${id}`,

  NOTIFICATION_MENTIONS: "/notifications/mentions",
};

const BUDGETS = {
  TEMPLATES: "/budgets/templates",
  CATALOG: "/budgets/catalog",
  PRESETS: "/budgets/presets",
  CLIENTS: "/budgets/clients",
  LIST: "/budgets",
  GET: (id) => `/budgets/${id}`,
  CREATE: "/budgets",
};

const PRODUCTS = {
  LIST: "/products",
  GET: (id) => `/products/${id}`,
  CREATE: "/products",
  UPDATE: (id) => `/products/${id}`,
  DELETE: (id) => `/products/${id}`,
};

const TAGS = {
  // Lista/pesquisa paginada: ?q=&limit=&offset=&orderBy=&order=
  LIST: (companyId) => `/companies/${companyId}/tags`,

  // Obter uma tag específica
  GET: (companyId, tagId) => `/companies/${companyId}/tags/${tagId}`,

  // Criar tag: { name, color }
  CREATE: (companyId) => `/companies/${companyId}/tags`,

  // Atualizar tag: { name?, color? }
  UPDATE: (companyId, tagId) => `/companies/${companyId}/tags/${tagId}`,

  // Remover tag
  DELETE: (companyId, tagId) => `/companies/${companyId}/tags/${tagId}`,

  // Upsert em massa: [{ name, color }, ...]
  BULK_UPSERT: (companyId) => `/companies/${companyId}/tags/bulk-upsert`,
};

const TEAMS = {
  // CRUD
  LIST: "/teams", // GET ?q=&status=&page=&perPage=
  CREATE: "/teams", // POST { name, description?, status?, members? }
  GET: (id) => `/teams/${id}`, // GET
  UPDATE: (id) => `/teams/${id}`, // PUT { name?, description?, status? }
  DELETE: (id) => `/teams/${id}`, // DELETE

  // membros
  LIST_USERS: (id) => `/teams/${id}/users`, // GET
  ADD_USERS: (id) => `/teams/${id}/users/add`, // POST { members: [{userId, role?}] }
  REMOVE_USERS: (id) => `/teams/${id}/users/remove`, // POST { userIds: [1,2,3] }
  SET_USERS: (id) => `/teams/${id}/users/set`, // PUT { members: [{userId, role}] }

  // funis do time
  LIST_FUNNELS: (id) => `/teams/${id}/funnels`, // GET
  COUNT_FUNNELS: (id) => `/teams/${id}/funnels/count`, // GET

  // meus times
  MY_TEAMS: "/teams/mine", // GET (usa req.user.id ou ?userId=)
};

const LEADS = {
  // CRUD/listagem
  LIST: "/leads", // GET ?page=&itemsPerPage=&search=&status=&ownerId=&tagId=&leadStageId=&companyId=&createdFrom=&createdTo=&lastContactFrom=&lastContactTo=&nextActionWindow=
  CREATE: "/leads", // POST
  GET: (id) => `/leads/${id}`, // GET
  UPDATE: (id) => `/leads/${id}`, // PATCH
  DELETE: (id) => `/leads/${id}`, // DELETE

  IMPORT: "/leads/import", // POST multipart/form-data

  // utilidades
  BY_EMAIL: "/leads/by-email", // GET ?email=&companyId=

  // ações
  ASSIGN_OWNER: (id) => `/leads/${id}/assign-owner`, // PATCH { ownerId }
  NEXT_ACTION: (id) => `/leads/${id}/next-action`, // PATCH { nextAction, nextActionAt, notesAppend }
  STATUS: (id) => `/leads/${id}/status`, // PATCH { status, lostReason?, lostNotes? }
  CONVERT: (id) => `/leads/${id}/convert`, // PATCH { cardId }
  TAG: (id) => `/leads/${id}/tag`, // PATCH { tagId }
  CONSENT: (id) => `/leads/${id}/consent`, // PATCH { consentMarketing: boolean }
  HISTORY: (id) => `/leads/${id}/history`, // GET

  // métricas
  STATS_BY_STATUS: "/leads/stats/status", // GET ?companyId= (se POWER_USER)
  CONTACTS: {
    LIST: (leadId) => `/leads/${leadId}/contacts`, // GET ?onlyActive=true|false
    ADD: (leadId) => `/leads/${leadId}/contacts`, // POST { type, value, label?, isPrimary?, status? }
    ADD_BATCH: (leadId) => `/leads/${leadId}/contacts/batch`, // POST [{...},...]
    UPDATE: (leadId, contactId) => `/leads/${leadId}/contacts/${contactId}`, // PATCH {...}
    SET_PRIMARY: (leadId, contactId) =>
      `/leads/${leadId}/contacts/${contactId}/primary`, // PATCH
    DELETE: (leadId, contactId) => `/leads/${leadId}/contacts/${contactId}`, // DELETE
  },
  CUSTOM_FIELDS: "/leads/custom-fields",
  CUSTOM_FIELD: (id) => `/leads/custom-fields/${id}`,
  CUSTOM_FIELDS_REORDER: "/leads/custom-fields/reorder",
};
const CRM_REPORTS = {
  GET_OVERVIEW: "/reports/overview",
};

const STAGE_FORMS = {
  // ---- CRUD de formulários por etapa ----
  LIST: "/stage-forms", // GET ?stageId=&isActive=true|false
  LATEST: "/stage-forms/latest", // GET ?stageId=
  CREATE: "/stage-forms", // POST { stageId, name, schema, version?, isActive? }
  UPDATE: (id) => `/stage-forms/${id}`, // PUT  { name?, schema?, version?, isActive? }
  DELETE: (id) => `/stage-forms/${id}`, // DELETE

  // ---- Respostas por card (histórico/validação) ----
  CARD: {
    LIST_RESPONSES: (cardId) => `/cards/${cardId}/forms`, // GET
    LAST_RESPONSE: (cardId, stageFormId) =>
      `/cards/${cardId}/forms/${stageFormId}/last`, // GET
    SAVE_RESPONSE: (cardId) => `/cards/${cardId}/forms`, // POST { stageFormId, answers, filledByUserId? }
    VALIDATE_ENTER: (cardId) => `/cards/${cardId}/forms/validate-enter`, // POST { toStageId }
    SAVE_AND_VALIDATE: (cardId) => `/cards/${cardId}/forms/save-and-validate`, // POST { toStageId, stageFormId?, answers?, filledByUserId? }
  },
};

const ACTIVITIES = {
  // Feed global do tenant (usa req.user.companyId no backend)
  // GET /api/activities
  // Query params opcionais: ?q=&actions=CARD_CREATED,CARD_UPDATED&targetType=&targetId=&actorUserId=&dateFrom=&dateTo=&page=&itemsPerPage=
  LIST_GLOBAL: "/activities",

  // Timeline por Card
  // GET /api/cards/:cardId/activities
  // Ex.: ACTIVITIES.LIST_BY_CARD(123) -> "/cards/123/activities"
  // Aceita os mesmos query params do global.
  LIST_BY_CARD: (cardId) => `/cards/${cardId}/activities`,
};

const ONBOARDING = {
  GET: "/onboarding/status",
  POST: "/onboarding",
  SKIP: "/onboarding/skip",
};

const NOTIFICATIONS = {
  LIST: () => `/notifications`,

  // Marca UMA notificação como lida
  // Ex.: PATCH NOTIFICATIONS.MARK_ONE_READ(id)
  MARK_ONE_READ: (id) => `/notifications/${id}/read`,

  // Marca TODAS como lidas
  // Ex.: POST NOTIFICATIONS.MARK_ALL_READ
  MARK_ALL_READ: `/notifications/mark-all-read`,
};

const CHAT = {
  DM_ENSURE: "/chat/dm/ensure", // POST { userId }
  DM_LIST: "/chat/dm", // GET
  DM_MESSAGES: (threadId) => `/chat/dm/${threadId}/messages`, // GET
  DM_SEND: `/chat/dm/messages`,
  PRESENCE: "/chat/presence",
};

const AI = {
  INSIGHTS: "/insights", // POST { userId }
};

const CUSTOM_FIELDS = {
  LIST: (funnelId) => `/crm/funnels/${funnelId}/custom-fields`,
  UPSERT: (funnelId) => `/crm/funnels/${funnelId}/custom-fields`,
  DELETE: (funnelId, fieldId) =>
    `/crm/funnels/${funnelId}/custom-fields/${fieldId}`,
};

let SOCKET_URL = "";
if (process.env.NODE_ENV === "development") {
  SOCKET_URL = "http://localhost:3000";
} else if (process.env.NODE_ENV === "production") {
  SOCKET_URL = "https://app.relinqsales.com.br";
}

export {
  API,
  DASHBOARD,
  LOGIN,
  PASSWORD_RECOVERY,
  LOAN,
  BLACKLIST,
  CATEGORIES,
  COMPANY,
  USERS,
  ADMIN,
  CHARGES,
  QUERIES,
  QUERIES_VEICULAR,
  AUDITS,
  AVATAR,
  PAYMENTS,
  REPORTS,
  SURVEYS,
  CRM,
  BUDGETS,
  PRODUCTS,
  TAGS,
  TEAMS,
  LEADS,
  INTEGRATIONS,
  STAGE_FORMS,
  ACTIVITIES,
  BASE_URL,
  ONBOARDING,
  NOTIFICATIONS,
  CHAT,
  AI,
  CUSTOM_FIELDS,
  CRM_REPORTS,
  SOCKET_URL,
};
